<template>
    <pm-custom-dialog v-if="visible" v-model="visible">
        <span slot="close-btn"></span>

        <div style="background: url(/images/onboarding/thinking.jpg) center center / contain no-repeat rgb(255, 255, 255); margin: 0px 0px 20px 0; width: 100%; height: 150px;"></div>

        <div style="margin-bottom: 16px; margin-top: 20px; text-align: center;">

            <h2 style="line-height: 1.2; font-weight: 600; text-shadow: 0.5px 0.5px 0 #000;">
                Oops…
            </h2>
            <h3 style="margin-top: 10px; font-size: 18px; line-height: 1.2; font-weight: 600; text-shadow: 0.5px 0.5px 0 #000;">
                Something went wrong
            </h3>
        </div>

        <p style="line-height: 1.3; font-size: 15px; margin-bottom: 8px; padding: 16px 30px;">

            We are eager to help you. Please let us know what was the problem.
        </p>

        <template v-if="!reason">
            <!-- <a class="retry-btn mb-3 pm-animation-fade-in-slide-down" style="--delay: 50ms" @click="reason='not_yet'">
                I'M NOT READY TO SUBSCRIBE
            </a>
            <br/> -->
            <a class="retry-btn mb-3 pm-animation-fade-in-slide-down" style="--delay: 100ms" @click="reason='payment_failed'">
                I COULDN'T SUBSCRIBE
            </a>
            <br/>
            <!-- <a class="retry-btn mb-3 pm-animation-fade-in-slide-down" style="--delay: 150ms" @click="reason='retry'">
                RETRY NOW
            </a> -->

            <pm-iap-product-button override-class="retry-btn mb-3 pm-animation-fade-in-slide-down" style="--delay: 150ms;" referrer="click_iap_error_retry" text="RETRY" />

            <br/>

            <a class="close-btn mb-3 pm-animation-fade-in-slide-down" style="--delay: 200ms" @click="reason = 'close'">
                <v-icon style="color: #2962ff; font-size:16px; margin-right: 6px;">close</v-icon> CLOSE
            </a>
        </template>
    </pm-custom-dialog>
</template>
<script>
import PmCustomDialog from "./base-dialog.vue";
import { retryStoreConnection } from "@/utils/iap/store-connection";
import { callSlackWebhook } from "@/utils/webhooks/slack";
import PmIapProductButton from "@/components/core/iap-product-button.vue";
export default {
    components: {
        PmCustomDialog,
        PmIapProductButton,
    },
    data: () => ({
        email: localStorage.getItem('userEmailSend') || localStorage.getItem('userEmail') || "",
        // reason: localStorage.getItem('storeErrorReason') || "",
        reason: "",
        visible: false,
    }),
    watch: {
        email() {
            // Store own email
            localStorage.setItem("userEmailSend", this.email);
        },
        reason() {
            localStorage.setItem('storeErrorReason', this.reason);
            window.Tracker.logEvent({
                event_name: "error_reason",
                event_category: "iap",
                event_label: this.reason,
            });

            if (this.reason === "not_yet") {
                this.$bus.$emit('openAppDialog','priceWorthIt');
            }

            if (this.reason === "payment_failed") {
                this.report();
            }

            if (this.reason === "retry") {
                this.retry();
            }

            if (this.reason === "close") {
                this.close();
            }
        },
    },
    methods: {
        retry() {
            app.$bus.$emit('openAppDialog','premium',{'title': '', 'referrer': 'click_retry_error'});
            IAP.autoRetryPurchase = true;

            window.Tracker.logEvent({
                event_name: "retry",
                event_category: "iap",
                event_label: "error_dialog_" + this.reason,
            });
        },
        report() {
            app.$bus.$emit('openAppDialog','storeSupport');
            window.Tracker.logEvent({
                event_name: "support",
                event_category: "iap",
                event_label: "error_dialog_" + this.reason,
            });
        },
        show() {
            this.visible = true;
        },
        close() {
            this.visible = false;
            this.$emit('close');
        },
        sendReport() {
            const params = [
                "#bugreport",
                "IAP Error report - " + this.email + " " + JSON.stringify(window.IAP),
                true,
            ];
            callSlackWebhook(...params);
            this.close();
        },
    }
}
</script>
